import { store } from 'src/app/store';
import { extendedApiSlice as influencersCampaignApiSlice } from 'src/features/admin/campaigns/campaigns.slice';

import { extendedApiSlice as campaignApiSlice } from 'src/features/campaigns/campaigns.slice';
import { readStoredCampaigns } from 'src/features/campaigns/helpers/campaign-storage';
import { INFLUENCER_CONFIGS } from '../influencers.config';
import { mapCampaignFromDTO } from '../../hooks/use-active-campaign';
import { CampaignLifecycleType } from 'src/common/interfaces/campaigns';

export async function checkIsInInfluencersCampaign() {
  const activeCampaign = readStoredCampaigns().activeCampaign;
  const storedCampaignName = activeCampaign?.name;

  if (!storedCampaignName || !activeCampaign.type) return false;

  const { data: campaignData } = await store.dispatch(
    influencersCampaignApiSlice.endpoints.getInfluencersCampaigns.initiate({
      page: 1,
      limit: 100,
      name: storedCampaignName,
    }),
  );

  const campaign = campaignData?.data?.docs[0];

  if (!campaign) return false;

  const { page, isActive } = INFLUENCER_CONFIGS(campaign);

  const campaignPage = !window.location.pathname.includes('/details') && window.location.pathname.includes(page);
  const isInfluencerCampaign = isActive && campaignPage;

  return isInfluencerCampaign;
}

export async function getInfluencerCampaignName() {
  const { data: campaignData } = await store.dispatch(
    campaignApiSlice.endpoints.getCampaigns.initiate(),
  );

  if (!campaignData?.data) return null;
  const activeCampaigns = campaignData.data;

  const currentFlashSale = activeCampaigns.find(
    (campaign) => campaign.lifecycleType === CampaignLifecycleType.TIME_BASED,
  );

  return currentFlashSale ? mapCampaignFromDTO(currentFlashSale).name : null;
}